import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LatLngLiteral, AgmInfoWindow } from '@agm/core';
import { marker } from 'src/app/tools/models/entities/marker';
import { Leg } from 'src/app/tools/models/entities/leg-entity';



@Component({
    selector: 'lean-map',
    templateUrl: './lean-map.component.html',
    styleUrls: ['./lean-map.component.scss']
})

export class LeanMapComponent implements OnInit {

    circleRadius: number = 20000;
    zoom: number = 8;
    polygon: any;
    title = 'my-app';
    label: string;
    selected: boolean = false

    styleMap = [{
        featureType: "administrative.country",
        stylers: [{
            visibility: "off"
        }]
    }];

    options = {
        suppressMarkers: true,
    };


    @Input() latitude: number;
    @Input() longitude: number;
    @Input() waypoints: any[];
    @Input() origin: any;
    @Input() destination: any;
    @Input()
    set points(data: marker[]) {
        if (data !== null && data !== undefined && data.length > 0) {
            this._points = data;
         //   this.latitude = data[0].lat;
         //   this.longitude = data[0].lng;
        }
    }

    @Output() onSelect: EventEmitter<number> = new EventEmitter();
    @Output() onMapClick: EventEmitter<LatLngLiteral> = new EventEmitter();
    @Output() onAgmDirectionResponse: EventEmitter<Leg[]> = new EventEmitter();

    _points: marker[];

    constructor(
        protected toastr: ToastrService) {
    }

    ngOnInit() {
   //     this.setCurrentLocation();
    }

    setCurrentLocation() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                //this.zoom = 15;
            });
        }
    }


    markerDragEnd(m: marker, $event) {
      //  console.log('dragEnd', m, $event);
    }

    onMouseOver(agmInfoWindow: AgmInfoWindow) {
        agmInfoWindow.open();
    }
    onMouseOut(agmInfoWindow: AgmInfoWindow) {
        agmInfoWindow.close();
    }

    clickedMarker(point: marker, index: number) {
        this.onSelect.emit(index);
    }

    placeMarker(event) {
        this.onMapClick.emit({lat: event.coords.lat, lng: event.coords.lng});
    }

    getIndex(index: number) {
        return Math.min(index, this.waypoints.length - 1);
    }

    getInfoAboutPath(response){
        let legs: Leg[] = [];
        for(let leg of response.routes[0].legs) {
            legs.push({
                distanceValue: leg.distance.value,
                distanceText: leg.distance.text,
                durationValue: leg.duration.value,
                durationText: leg.duration.text
            })
        }
        this.onAgmDirectionResponse.emit(legs);
        // console.log(legs);
    }
}
